module.exports = __webpack_public_path__ + "static/media/wechat.f1765d99.png";